import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import Edit from "../../../../assets/images/editinput.svg";
import { Select } from "@appkit4/react-components/select";
import { Combobox } from "@appkit4/react-components";
import { Tabs, Tab } from "@appkit4/react-components/tabs";
import ConfermationModal from "../../../Common/DeleteModal";
import displayToastMessage from "../../../Common/Alert/displayToastMessage";
import PropTypes from "prop-types";
import APIService from "../../../../services/apiAxiosService";
import useHttp from "../../../../hooks/useHttp";
import { Tooltip } from '@appkit4/react-components/tooltip';

export default function IssueCreate(prop) {
  let { vendors, analyst, reload, priorityList, SetTabIssue } = prop;
  const [conformationVisible, setConformationVisible] = useState(false);
  const [save, setSave] = useState(false);
  const [draftValue, setDraftValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [riskName, setRiskName] = useState();
  const [remediationPlan, setRemediationPlan] = useState("");
  const [errorRemidiationplan, setErrorRemidiationplan] = useState("");
  const [title, setTitle] = useState("");
  const [errorTitle, setErrorTitle] = useState("");
  const [description, setDescription] = useState("");
  const [errorDescription, setErrorDescription] = useState("");
  const [workPerformed, setWorkPerformed] = useState("");
  const [errorWorkPerformed, setErrorWorkPerformed] = useState("");
  const [isErrorMessageShown, setIsErrorMessageShown] = useState(false);
  const [filterRiskId, setFilterRiskId] = useState([]);
  const [vendorid, setVendorid] = useState();
  const [currentTab, setCurrentTab] = useState("1");
  const { sendRequest: handleNotificationSubmitAPI } = useHttp();
  const { sendRequest: createIssueRequestAPI } = useHttp();
  const { sendRequest: getAssessmentRiskById } = useHttp();
  const { sendRequest: getRiskDataById } = useHttp();

 

  const handleTabs = (e, v) => {
    setCurrentTab(v);
  };

  const [assessmentId, setAssessmentId] = useState();

  const createIssueRequestResponse = (data, resetForm) => {
    if (data.CODE) {
      setLoading(false);
      resetForm();
      setConformationVisible(false);
      prop.handleBack();
      reload();
      let notifData = {
        paramuserid: Number(sessionStorage.getItem("userId")),
        paramreqid: vendorid,
        paramcontent: "Issue created successfully",
        paramnextroleid: 5,
        paramcreatedby: Number(sessionStorage.getItem("roleId")),
        parammsgtype: data.MSG,
      };
      handleNotificationSubmitAPI(
        APIService.handleNotificationSubmit(notifData),
        () => {}
      );
      displayToastMessage(data.MSG, "success");
      setDraftValue("");
      //resetForm();
    } else {
      let Msg = "Action failed. Please try again!";
      setLoading(false);
      setConformationVisible(false);
      displayToastMessage(Msg, "error");
      setDraftValue("");
    }
  };

  const handelSubmit = async (values, { resetForm }) => {
    let issueData = {
      Approval: values.Approval,
      AssessmentID: values.AssessmentID,
      ControlName: values.ControlName,
      ControlQuestionID: values.ControlQuestionID,
      IssueDetails: values.IssueDetails,
      IssueDueDate: values.IssueDueDate,
       IssueType: values.IssueType,
      Rating: values.Rating,
      RemediationPlan: remediationPlan,
      RiskID: values.RiskID,
      // RiskName: values.RiskName,
      ThirdPartyName: values.ThirdPartyName,
      Title: title,
      CreationDate: values.CreationDate,
      Description: description,
      StartDate: values.StartDate,
      EndDate: values.EndDate,
      WorkPerformed: workPerformed,
      created_by: Number(sessionStorage.getItem("userId")),
      vendor_id: vendorid,
      email:sessionStorage.getItem("email"),

    };
    if (draftValue != "4") {
      issueData.draft_status = "1";
    } else {
      issueData.draft_status = draftValue;
    }
    setLoading(true);

    await createIssueRequestAPI(
      APIService.createIssueRequest(issueData),
      (res) => createIssueRequestResponse(res, resetForm),
      (error) => {
        console.log("Error", error);
        setLoading(false);
        setConformationVisible(false);
        let Msg = "Action failed. Please try again!";
        displayToastMessage(Msg, "error");
      }
    );
  };

  let validateInputFields = (value) => {
    let reg = /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/;
    if (value.match(reg)) {
      return true;
    } else {
      return false;
    }
  };

  const handleRemediationPlan = (e) => {
    if (e.target.value === "") {
      setErrorRemidiationplan("");
      setRemediationPlan(e.target.value);
    } else {
      if (validateInputFields(e.target.value)) {
        setErrorRemidiationplan("");
        setRemediationPlan(e.target.value);
      } else {
        setIsErrorMessageShown(true);
        setErrorRemidiationplan("Special characters are not allowed");
      }
    }
  };

  const handleChangeTitle = (e) => {
    if (e.target.value === "") {
      setErrorTitle("");
      setTitle(e.target.value);
    } else {
      if (validateInputFields(e.target.value)) {
        setErrorTitle("");
        setTitle(e.target.value);
      } else {
        setIsErrorMessageShown(true);
        setErrorTitle("Special characters are not allowed");
      }
    }
  };

  const handleChangeDescription = (e) => {
    if (e.target.value === "") {
      setErrorDescription("");
      setDescription(e.target.value);
    } else {
      if (validateInputFields(e.target.value)) {
        setErrorDescription("");
        setDescription(e.target.value);
      } else {
        setIsErrorMessageShown(true);
        setErrorDescription("Special characters are not allowed");
      }
    }
  };

  const handleChangeWorkPerformed = (e) => {
    if (e.target.value === "") {
      setErrorWorkPerformed("");
      setWorkPerformed(e.target.value);
    } else {
      if (validateInputFields(e.target.value)) {
        setErrorWorkPerformed("");
        setWorkPerformed(e.target.value);
      } else {
        setIsErrorMessageShown(true);
        setErrorWorkPerformed("Special characters are not allowed");
      }
    }
  };

  const handelCancel = () => {
    setConformationVisible(false);
  };
  const handleDraft = (value) => {
    setDraftValue(value);
  };
  const getAssessmentRisk = async (ThirdPartyID) => {
    getAssessmentRiskById(
      APIService.getAssessmentRiskById(ThirdPartyID),
      (data) => {
        setAssessmentId(data.MSG);
        setVendorid(data.MSG[0].vendor_id);
      }
    );
  };
  const getRiskData = async (ThirdPartyID) => {
    getRiskDataById(APIService.getRiskDataById(ThirdPartyID), (data) => {
      setFilterRiskId(data.MSG);
    });
  };
  useEffect(() => {}, []);
  let initialValues = {
    ThirdPartyName: "",
    AssessmentID: "",
    IssueDetails: "",
    Rating:null,
    CreationDate: "",
    IssueDueDate: "",
    IssueType: null,
    RiskID: null,
    RiskName: "",
    ControlQuestionID: "",
    ControlName: "",
    //RemediationPlan: "",
    Approval: "",
    Title: "",
    Description: "",
    StartDate: "",
    EndDate: "",
    WorkPerformed: "",
    //addActions: [{ Title: "", Description: "", StartDate: "",EndDate:"",WorkPerformed:"" }],
  };
  return (
    <div>
      <div className="row text-right pt-3">
        <div className="col-md-12">
          {prop.mode === "create" ? null : (
            <span
              className="Appkit4-icon icon-arrow-left-outline pointer back-fill"
              onClick={prop.handleBack}
            ></span>
          )}
        </div>
      </div>
      <Formik
        initialValues={initialValues}
        onSubmit={handelSubmit}
        validationSchema={Yup.object().shape({
          ThirdPartyName: Yup.string()
            .required("Third party name is Required.")
            .matches(
              /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
              "Only alphabets and numbers are allowed for this field "
            ),
          AssessmentID: Yup.string()
            .required("Assessment ID is Required.")
            .matches(
              /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
              "Only alphabets and numbers are allowed for this field "
            ),
          IssueDetails: Yup.string()
            .required("Issue details is Required.")
            .matches(
              /^[a-zA-Z\d\-_.,&#()\s]+$/,
              "Only alphabets, numbers and some special characters are allowed for this field "
            ),
          
          CreationDate: Yup.string().required("Creation date is Required."),
          IssueDueDate: Yup.string().required("Issue due date is Required."),
         
        
          ControlQuestionID: Yup.string()
            .required("Control/question ID is Required.")
            .matches(
              /^[a-zA-Z\d\-_.,&#()\s]+$/,
              "Only alphabets, numbers and some special characters are allowed for this field "
            ),
          ControlName: Yup.string()
            .required("Control name is Required.")
            .matches(
              /^[a-zA-Z\d\-_.,&#()\s]+$/,
              "Only alphabets, numbers and some special characters are allowed for this field "
            ),
          Approval: Yup.string()
            .required("Approval is Required.")
            .matches(
              /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
              "Only alphabets and numbers are allowed for this field "
            ),
          // addActions: Yup.array().of(
          //   Yup.object().shape({
          //     Title: Yup.string().required("Please enter title").matches(
          //       /^[a-zA-Z\d\-_.,&#()\s]+$/,
          //       "Only alphabets, numbers and some special characters are allowed for this field "
          //     ),
          //     Description: Yup.string().required("Please enter description").matches(
          //       /^[a-zA-Z\d\-_.,&#()\s]+$/,
          //       "Only alphabets, numbers and some special characters are allowed for this field "
          //     ),
          //     StartDate: Yup.string()
          //       .required("Please select end date"),
          //   EndDate:Yup.string()
          //   .required("Please select start date"),
          //   WorkPerformed:Yup.string().required("Please enter work performed").matches(
          //     /^[a-zA-Z\d\-_.,&#()\s]+$/,
          //     "Only alphabets, numbers and some special characters are allowed for this field "
          //   ),
          //   })
          // ),
        })}
      >
        {(props) => {
          const {
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
          } = props;
          return (
            <div className="">
              {loading ? (
                <div className="row" id="preloader">
                  <div className="col-12 col-lg-12 loader-margin text-center">
                    <div className="a-loading a-primary a-m-10" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label className="cv-input-label">
                          Third Party Name <span className="asterisk-required">*</span>
                        </label>
                        <Select
                          className="cv-input-field"
                          dropdownRenderMode="portal"
                          data={vendors}
                          valueKey="vendor_id"
                          labelKey="vendor_name"
                          showSearchOnToggle={true}
                          onSelect={(e) => {
                            handleChange("ThirdPartyName")({
                              target: { value: e },
                            });
                            getAssessmentRisk(e);
                            getRiskData(e);
                          }}
                          name="ThirdPartyName"
                          value={values.ThirdPartyName}
                          placeholder="Select Third Party Name"
                        ></Select>
                      </div>
                      {errors.ThirdPartyName && touched.ThirdPartyName && (
                        <div className="form-label error">
                          {errors.ThirdPartyName}
                        </div>
                      )}
                    </div>

                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label className="cv-input-label">
                          Assessment <span className="asterisk-required">*</span>
                        </label>
                        <select
                          className="cv-input-field"
                          type="text"
                          value={values.AssessmentID}
                          onChange={handleChange("AssessmentID")}
                          name="AssessmentID"
                        >
                          <option key="0">Select Assessment Name</option>
                          {assessmentId?.map((each, index) => {
                              return (
                                <option key={each.assessment_name} value={each.assessment_id}>
                                  {each.assessment_name}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                      {errors.AssessmentID && touched.AssessmentID && (
                        <div className="form-label error">
                          {errors.AssessmentID}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label htmlFor="issueDetailsEdit" className="cv-input-label">
                          Issue Details <span className="asterisk-required">*</span>
                        </label>
                        <input
                          name="IssueDetails"
                          type="text"
                          id="issueDetailsEdit"
                          placeholder="IssueDetails"
                          value={values.IssueDetails}
                          onChange={handleChange("IssueDetails")}
                          onBlur={handleBlur}
                          className="cv-input-field ml-3"
                        />
                        <img alt="edit" src={Edit} className="edit-input" />
                      </div>
                      {errors.IssueDetails && touched.IssueDetails && (
                        <div className="error-msg">{errors.IssueDetails}</div>
                      )}
                    </div>
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label htmlFor="CreationDateEdit" className="cv-input-label">
                          Creation Date <span className="asterisk-required">*</span>
                        </label>
                        <input
                          name="CreationDate"
                          type="date"
                          id="CreationDateEdit"
                          placeholder="CreationDate"
                          value={values.CreationDate}
                          onChange={handleChange("CreationDate")}
                          onBlur={handleBlur}
                          className="cv-input-field"
                        />
                      </div>
                      {errors.CreationDate && touched.CreationDate && (
                        <div className="error-msg">{errors.CreationDate}</div>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="cv-input-field-container">
                        <label htmlFor="IssueDueDateEdit" className="cv-input-label">
                          Issue Due Date <span className="asterisk-required">*</span>
                        </label>
                        <input
                          name="IssueDueDate"
                          type="date"
                          id="IssueDueDateEdit"
                          placeholder="IssueDueDate"
                          value={values.IssueDueDate}
                          onChange={handleChange("IssueDueDate")}
                          onBlur={handleBlur}
                          className="cv-input-field"
                        />
                      </div>
                      {errors.IssueDueDate && touched.IssueDueDate && (
                        <div className="error-msg">{errors.IssueDueDate}</div>
                      )}
                    </div>
                  </div>
                  <div className="mt-3">
                    <Tabs
                      defaultValue={currentTab}
                      value={currentTab}
                      onChange={handleTabs}
                      className="a-tab-item-padding-10"
                    >
                     
                      <Tab value="3" label="Control/Question Mapping">
                        <div className="col-sm-6 mt-3">
                          <div className="cv-input-field-container">
                            <label htmlFor="ControlQuestionIDEdit" className="cv-input-label">
                              Control/ Question ID
                              <span className="asterisk-required">*</span>
                            </label>
                            <input
                              name="ControlName"
                              type="text"
                              id="ControlQuestionIDEdit"
                              placeholder="ControlQuestionID"
                              value={values.ControlQuestionID}
                              onChange={handleChange("ControlQuestionID")}
                              onBlur={handleBlur}
                              className="cv-input-field ml-3"
                            />
                            <img alt="edit" src={Edit} className="edit-input" />
                            {/* <Select
                              className="cv-input-field"
                              onBlur={handleBlur}
                              onSelect={(e) =>
                                handleChange("ControlQuestionID")({
                                  target: { value: e },
                                })
                              }
                              name="ControlQuestionID"
                              value={values.ControlQuestionID}
                              multiple
                              placeholder="Select Control Question ID"
                            >
                              <SelectGroupTitle>
                                Select Control/Question ID
                              </SelectGroupTitle>
                              <SelectOption key="1" value={1}>
                                Tier-1
                              </SelectOption>
                              <SelectOption key="2" value={2}>
                                Tier-2
                              </SelectOption>
                            </Select> */}
                          </div>
                          {errors.ControlQuestionID &&
                            touched.ControlQuestionID && (
                              <div className="form-label error">
                                {errors.ControlQuestionID}
                              </div>
                            )}
                        </div>

                        <div className="col-sm-6 mt-2">
                          <div className="cv-input-field-container">
                            <label htmlFor="ControlNameEdit" className="cv-input-label">
                              Control Name <span className="asterisk-required">*</span>
                            </label>
                            <input
                              name="ControlName"
                              type="text"
                              id="ControlNameEdit"
                              placeholder="ControlName"
                              value={values.ControlName}
                              onChange={handleChange("ControlName")}
                              onBlur={handleBlur}
                              className="cv-input-field ml-3"
                            />
                             <Tooltip
        trigger='hover'
        position='top-left'
        distance={4}
        id="tooltipDesc"
        appendAfterTarget={true}
        content={values.ControlName}
      >
                            <img alt="edit" src={Edit} className="edit-input" /></Tooltip>
                          </div>
                          {errors.ControlName && touched.ControlName && (
                            <div className="error-msg">
                              {errors.ControlName}
                            </div>
                          )}
                        </div>
                      </Tab>
                      <Tab value="4" label="Remediation Plan">
                        <div className="col-sm-6 mt-3">
                          <div className="cv-input-field-container">
                            <label className="cv-input-label">
                              Remediation Plan
                            </label>
                            <input
                              name="RemediationPlan"
                              type="text"
                              placeholder="Please enter RemediationPlan"
                              value={remediationPlan}
                              onChange={handleRemediationPlan}
                              className="cv-input-field"
                            />
                            <img alt="edit" src={Edit} className="edit-input" />
                          </div>
                          <div className="cv-input-field">
                            <span
                              className="form-label errorMsg"
                              style={{
                                display: isErrorMessageShown ? "block" : "none",
                              }}
                            >
                              {errorRemidiationplan}
                            </span>
                          </div>
                        </div>
                      </Tab>
                      <Tab value="5" label="Add Action">
                        <div className="col-sm-6 mt-3">
                          <div className="cv-input-field-container">
                            <label className="cv-input-label">Title</label>
                            <input
                              name="Title"
                              type="text"
                              placeholder="Please enter title"
                              value={title}
                              onChange={handleChangeTitle}
                              className="cv-input-field"
                            />
                            <img alt="edit" src={Edit} className="edit-input" />
                          </div>
                          <div className="cv-input-field">
                            <span
                              className="form-label errorMsg"
                              style={{
                                display: isErrorMessageShown ? "block" : "none",
                              }}
                            >
                              {errorTitle}
                            </span>
                          </div>
                        </div>
                        <div className="col-sm-6 mt-2">
                          <div className="cv-input-field-container">
                            <label className="cv-input-label">
                              Description
                            </label>
                            <input
                              name="Description"
                              type="Description"
                              id="Description"
                              placeholder="Please enter description"
                              value={description}
                              onChange={handleChangeDescription}
                              className="cv-input-field"
                            />
                            <img alt="edit" src={Edit} className="edit-input" />
                          </div>
                          <div className="cv-input-field">
                            <span
                              className="form-label errorMsg"
                              style={{
                                display: isErrorMessageShown ? "block" : "none",
                              }}
                            >
                              {errorDescription}
                            </span>
                          </div>
                        </div>
                        <div className="col-sm-6 mt-2">
                          <div className="cv-input-field-container">
                            <label htmlFor="StartDateEdit" className="cv-input-label">Start Date</label>
                            <input
                              name="StartDate"
                              type="date"
                              id="StartDateEdit"
                              placeholder="StartDate"
                              value={values.StartDate}
                              onChange={handleChange("StartDate")}
                              onBlur={handleBlur}
                              className="cv-input-field"
                            />
                          </div>
                        </div>
                        <div className="col-sm-6 mt-2">
                          <div className="cv-input-field-container">
                            <label htmlFor="EndDateEdit" className="cv-input-label">End Date</label>
                            <input
                              name="EndDate"
                              type="date"
                              id="EndDateEdit"
                              placeholder="EndDate"
                              value={values.EndDate}
                              onChange={handleChange("EndDate")}
                              onBlur={handleBlur}
                              className="cv-input-field"
                            />
                          </div>
                        </div>
                        <div className="col-sm-6 mt-2">
                          <div className="cv-input-field-container">
                            <label className="cv-input-label">
                              Work Performed
                            </label>
                            <input
                              name="WorkPerformed"
                              type="text"
                              id="WorkPerformed"
                              placeholder="Please enter work performed"
                              value={workPerformed}
                              onChange={handleChangeWorkPerformed}
                              className="cv-input-field"
                            />
                            <img alt="edit" src={Edit} className="edit-input" />
                          </div>
                          <div className="cv-input-field">
                            <span
                              className="form-label errorMsg"
                              style={{
                                display: isErrorMessageShown ? "block" : "none",
                              }}
                            >
                              {errorWorkPerformed}
                            </span>
                          </div>
                        </div>
                      </Tab>
                      <Tab value="6" label="Approval">
                        <div className="col-sm-6 mt-3">
                          <div className="cv-input-field-container">
                            <label className="cv-input-label">
                              Analyst <span className="asterisk-required">*</span>
                            </label>
                            <select
                              className="cv-input-field"
                              type="text"
                              value={values.Approval}
                              onChange={handleChange("Approval")}
                              name="Approval"
                            >
                              <option key="0">Select Analyst</option>
                              {analyst?.map((each, index) => {
                                  return (
                                    <option key={each.analyst_name} value={each.analyst_id}>
                                      {each.analyst_name}
                                    </option>
                                  );
                                })}
                            </select>
                          </div>
                          {errors.Approval && touched.Approval && (
                            <div className="error-msg">{errors.Approval}</div>
                          )}
                        </div>
                      </Tab>
                    </Tabs>
                  </div>
                  <div className="options-container">
                    {prop.mode === "create" && (
                      <button type="submit" className="save-button m-l-2">
                        Initiate Issue
                      </button>
                    )}
                    <button
                      type="submit"
                      className="save-button m-l-2"
                      onClick={() => handleDraft("4")}
                    >
                      Save
                    </button>
                    <button
                      className="cancel-button m-l-2"
                      type="reset"
                      onClick={prop.handleBack}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              )}
            </div>
          );
        }}
      </Formik>
      <ConfermationModal
        content={
          save
            ? "Do you want to create a new issue?"
            : "Do you want to save the issue?"
        }
        visible={conformationVisible}
        cancel={handelCancel}
        // confirm={handelConform}
      />
    </div>
  );
}

IssueCreate.propTypes = {
  values: PropTypes.any,
  touched: PropTypes.any,
  errors: PropTypes.any,
  handleChange: PropTypes.any,
  handleBlur: PropTypes.any,
  handleSubmit: PropTypes.any,
}
